import {useQuery} from '@tanstack/react-query';

import {useApiClient} from '@/hooks';

import {payoutsApi} from '../api';

export const payoutInstructionKeys = {
  all: (trustAccountId: string) =>
    ['trust-accounts', trustAccountId, 'payout-instructions'] as const,
  lists: (trustAccountId: string) => [...payoutInstructionKeys.all(trustAccountId), 'list'] as const
};

export function usePayoutInstructionsQuery(trustAccountId: string) {
  const client = useApiClient();

  return useQuery({
    queryKey: payoutInstructionKeys.lists(trustAccountId),
    queryFn: () => payoutsApi.fetchPayoutInstructions(client, trustAccountId),
    enabled: !!trustAccountId,
    select: response => response.data
  });
}
